import { Navigate } from "react-router-dom";
import { useAuth } from "../context/AuthContext";
import PageLoader from './PageLoader';

const ProtectedRoute = ({ children, allowedRoles = [] }) => {
  const { isLoggedIn, loading, role } = useAuth();

  if (loading) {
    return <PageLoader />;
  }

  if (!isLoggedIn) {
    return <Navigate to="/" replace />;
  }

  if (allowedRoles.length > 0 && !allowedRoles.includes(role)) {
    return <Navigate to="/" replace />;
  }


  return isLoggedIn ? children : <Navigate to="/" replace />;
};

export default ProtectedRoute;